import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

type UseExportProductsMutationProps = {
	onSuccess: (data: any) => void
	onSettled: () => void
}

export const useExportProductsMutation = ({
	onSuccess,
	onSettled
}: UseExportProductsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportProductsMutation, isPending: isExportProductsLoading } = useMutation({
		mutationFn: ({ ids, format }: { ids: number[]; format: number | string | null }) => {
			return axiosPrivate.post(apiRoutes.productsExport, {
				format,
				ids
			})
		},
		onSuccess: (res) => {
			onSuccess(res)

			useToast({
				type: 'success',
				message: t('Export request succeeded')
			})
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		exportProductsMutation,
		isExportProductsLoading
	}
}
